
export interface FastmenuState {
    loadFastmenu?: boolean;
    fastmenuData?: Array<any>;
}

export enum FastmenuActionTypes {
    GET_FASTMENU_REQUEST = 'GET_FASTMENU_REQUEST',
    GET_FASTMENU_SUCCESS = 'GET_FASTMENU_SUCCESS',
    GET_FASTMENU_ERROR = 'GET_FASTMENU_ERROR',
    UPDATE_FASTMENU_REQUEST = 'UPDATE_FASTMENU_REQUEST',
    UPDATE_FASTMENU_SUCCESS = 'UPDATE_FASTMENU_SUCCESS',
    UPDATE_FASTMENU_ERROR = 'UPDATE_FASTMENU_ERROR',
    ADD_FAVORITE_FASTMENU_REQUEST = 'ADD_FAVORITE_FASTMENU_REQUEST',
    ADD_FAVORITE_FASTMENU_SUCCESS = 'ADD_FAVORITE_FASTMENU_SUCCESS',
    ADD_FAVORITE_FASTMENU_ERROR = 'ADD_FAVORITE_FASTMENU_ERROR',
}

interface SetFastmenuRequestAction {
    type: FastmenuActionTypes.GET_FASTMENU_REQUEST
}

interface SetFastmenuSuccessAction {
    type: FastmenuActionTypes.GET_FASTMENU_SUCCESS;
    payload: any;
}

interface SetFastmenuErrorAction {
    type: FastmenuActionTypes.GET_FASTMENU_ERROR;
    error: any;
}

interface SetFastmenuUpdateRequestAction {
    type: FastmenuActionTypes.UPDATE_FASTMENU_REQUEST
}

interface SetFastmenuUpdateSuccessAction {
    type: FastmenuActionTypes.UPDATE_FASTMENU_SUCCESS;
    payload: any;
}

interface SetFastmenuUpdateErrorAction {
    type: FastmenuActionTypes.UPDATE_FASTMENU_ERROR;
    error: any;
}

interface SetFastmenuAddFavoriteRequestAction {
    type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_REQUEST
}

interface SetFastmenuAddFavoriteSuccessAction {
    type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_SUCCESS;
    payload: any;
}

interface SetFastmenuAddFavoriteErrorAction {
    type: FastmenuActionTypes.ADD_FAVORITE_FASTMENU_ERROR;
    error: any;
}


export type FastmenuAction =
    SetFastmenuRequestAction |
    SetFastmenuSuccessAction |
    SetFastmenuErrorAction   |
    SetFastmenuUpdateRequestAction |
    SetFastmenuUpdateSuccessAction |
    SetFastmenuUpdateErrorAction |
    SetFastmenuAddFavoriteRequestAction |
    SetFastmenuAddFavoriteSuccessAction |
    SetFastmenuAddFavoriteErrorAction